import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Podcasts from "@/pages/Podcasts";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Ministry from "@/pages/Ministry";
import Testimonies from "@/pages/Testimonies";
import FAQ from "@/pages/FAQ";
import Sunday from "@/pages/Sunday";
import Admin from "@/pages/Admin";

function App() {
  useEffect(() => {
    document.title = "Jesus Talk — Le média qui encourage ta foi au quotidien";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route
            path="*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/podcasts" element={<Podcasts />} />
                  <Route path="/a-propos" element={<About />} />
                  <Route path="/ministere" element={<Ministry />} />
                  <Route path="/temoignages" element={<Testimonies />} />
                  <Route path="/dimanche" element={<Sunday />} />
                  <Route path="/ressources" element={<Resources />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
